import React, { Component, Fragment } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import CounterOne from "../elements/counters/CounterOne";
import Testimonial from "../elements/Testimonial";
import BrandTwo from "../elements/BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import Team from "../elements/Team";
import Brand from "../elements/Brand";

class About extends Component{
    render(){
        let title = 'Sobre nosotros',
        description = 'Somos un grupo de apasionados por el desarrollo de proyectos de software que con 13-15 años empezó a realizar redes de servidores de videojuegos, entre ellas una de las más famosas a nivel de habla hispana en el videojuego Minecraft con más de medio millón de usuarios. A partir de ahí hemos realizado numerosos proyectos. Entre ellos se encuentran aplicaciones móviles como Go2Market, tiendas de venta de videojuegos, desarrollo de servidores personalizados y modificaciones de videojuegos para series de influencers en Twitch (Ibai, IlloJuan, etc).',
        description2= ' A dia de hoy, con casi una década de proyectos a nuestras espaldas, hemos decidido no solo hacer proyectos individuales sino abrirnos al público para ofrecerles nuestros servicios. Entre nuestros principales clientes se encuentran el Gobierno de Tamaulipas (México), Zerobolas, y el Congreso de Fenamix, una red española de puestos de loterias.';

        return(
            <Fragment>
                <PageHelmet pageTitle='Acerca de' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Acerca de'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">{title}</h2>
                                            <p className="description">{description}</p>
                                            <p className="description">{description2}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Nuestra historia</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div>
                {/* End CounterUp Area */}


               {/* Start Call To Action Area  */}
               <div className="call-to-action-wrapper call-to-action bg_image bg_image--5 text-white-wrapper ptb--90 ptb_lg--80 ptb_md--80 ptb_sm--80" id="getstart">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="inner text-left">
                                    <span>¿TIENES UNA IDEA?</span>
                                    <h2>Da forma a tu proyecto</h2>
                                    <a className="rn-button-style--2 mt--70 mt_sm--30 mt_md--30" href="/contact"><span>Contacta con nosotros</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Call To Action Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Nuestro equipo</h2>
                                    <p>Los profesionales que van a llevar a cabo tus futuros proyectos.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Team column="col-lg-4 col-md-6 col-sm-6 col-12" />
                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Brand Area */}
                <div className="rn-team-area bg_color--1 pb--120">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Nuestros clientes</h2>
                                    <p>Principales empresas que han decidido realizar sus proyectos con nosotros.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 ">
                                <Brand branstyle="branstyle--2" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Brand Area */}

                {/* Start Testimonial Area 
                <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div>*/}
                {/* End Testimonial Area */}
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </Fragment>
        )
    }
}
export default About